import { ROLES_BY_ROLES, ROLES_NAME } from "@/_old/enums/roles-name";

export const getRoleName = (role: ROLES_NAME): ROLES_BY_ROLES => {
  switch (role) {
    case ROLES_NAME.ADMIN:
      return ROLES_BY_ROLES.admin;
    case ROLES_NAME.ADMINCW:
      return ROLES_BY_ROLES["admin-cw"];
    case ROLES_NAME.MANAGER:
      return ROLES_BY_ROLES["admin-co"];
    case ROLES_NAME.SUBMANAGER:
      return ROLES_BY_ROLES["admin-co-sub"];
    default:
      return ROLES_BY_ROLES[""];
  }
};
